import { type LinkProps } from 'next/link';
import { ReactNode } from 'react';

import styles from './locations.module.css';
import { Link } from '../link/link';
import { List } from '../list/list';
import { ListItem } from '../list/list-item';
import { Tooltip } from '../tooltip/tooltip';

export type LocationsProps = {
  trigger: ReactNode;
  countries: Array<{
    countryName: string;
    cities: Array<{
      cityName: string;
      href: LinkProps['href'];
    }>;
  }>;
};

export const Locations = ({ trigger, countries }: LocationsProps) => {
  return (
    <Tooltip trigger={trigger}>
      <div className={styles.locations}>
        {countries.map(({ countryName, cities }) => (
          <List title={countryName} key={countryName}>
            {cities.map(({ cityName, href }) => {
              const linkProps = {
                href,
                children: cityName,
              };

              return (
                <ListItem key={cityName}>
                  <Link {...linkProps} />
                </ListItem>
              );
            })}
          </List>
        ))}
      </div>
    </Tooltip>
  );
};
